import { axiosClient } from './axios_client';

export const mqtt_api = {
  status: () => axiosClient.get('/api/mqtt', { params: { _t: Date.now() } }),
  messages: () => axiosClient.get('/api/mqtt/messages', { params: { _t: Date.now() } }),
  simulate: (data) => axiosClient.post('/api/mqtt/simulate', data),
  simulateLoopStatus: () => axiosClient.get('/api/mqtt/simulate/loop', { params: { _t: Date.now() } }),
  simulateLoop: (data) => axiosClient.post('/api/mqtt/simulate/loop', data),
  credentials: () => axiosClient.get('/api/mqtt/credentials', { params: { _t: Date.now() } }),
  createCredential: (data) => axiosClient.post('/api/mqtt/credentials', data),
  deleteCredential: (deviceId) => axiosClient.delete(`/api/mqtt/credentials/${encodeURIComponent(deviceId)}`),
};
